import { render, staticRenderFns } from "./QuestionNaire.vue?vue&type=template&id=b6aaa740&scoped=true"
import script from "./QuestionNaire.vue?vue&type=script&lang=js"
export * from "./QuestionNaire.vue?vue&type=script&lang=js"
import style0 from "./QuestionNaire.vue?vue&type=style&index=0&id=b6aaa740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6aaa740",
  null
  
)

export default component.exports